import React from 'react'
import Navbar from './navbar'
import Cards from './Blog/Cards'

const Blog = () => {
  return (
    <>
      <Navbar />
      <Cards />

      {/* <div className="max-w-sm rounded overflow-hidden shadow-lg m-4">
        <img
          className="w-full h-48 object-cover object-top"
          src="https://images.unsplash.com/photo-1597892672196-3bb8b5c06171?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="Blog Post"
        />
        <div className="px-6 py-4">
          <div className="font-bold text-xl mb-2">Blog Title</div>
          <p className="text-gray-700 text-base">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>
        <div className="px-6 py-4">
          <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">#Tag1</span>
          <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">#Tag2</span>
          <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700">#Tag3</span>
        </div>
      </div> */}
    </>
  )
}

export default Blog